import { useStore } from "utils/useStore";
import SignalsPageStore from "./Store/SignalsPageStore";

/**
 * Gets the current dashboard from the SignalsPageStore. The dashboard may be null if the currentDashboardId is invalid
 * @returns The current dashboard or null if one is not set.
 */
export function useCurrentDashboard() {
    const signalsPageStore = useStore(SignalsPageStore);

    return signalsPageStore.currentDashboard;
}
